import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import formatDate from "../../common/Formatdate";
import formatDateAndTime from "../../common/formatDateAndTime";
import BookingDetailsCard from "./Bookingdetailscard";
import moment from "moment";
import Commonmodal from "../../common/Commonmodal";
import toast from "react-hot-toast";
import InfoIcon from "@mui/icons-material/Info";
import Aisummarizecomment from "./Aisummarizecomment";

const Summary = ({
  summaryDetails,
  vehicleDetails,
  paymentDetailsData,
  transactionDetails,
  from,
  selectedRow,
  setActiveTab,
  systemUserData,
  setSystemUserData,
  bookingExtensionDetails,
  bookingRescheduleDetails,
  getVehicleWappingDetails,
  bookingCalleationPloicies,
  getticketDetails,
  getBookingExtensionDetails,
  setBookingExtensionDetails,
  getBookingReschduleDetails,
  setBookingRescheduleDetails,
  vehicelSwappingDetails,
  setVehicleSwappingDetails,
  bookingCancellationDetails,
  setBookingCancellationDetails,
  ticketDetails,
  setTicketDetails,
  cities,
  getAllHubsListData,
  getAllBookings,
  setOpenTab,
  getBookingDetail,
  setActiveItem,
  bookingComments,
  getAISummarizedResultAPI,
  aiSummarizedResult,
  aiSummarizeLoading,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let vehicleBodyType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBodyType;
  let fuelType = JSON.parse(localStorage.getItem("catalogValues"))?.fuelType;
  let transmissionType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.transmissionType;
  let vehicleStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleStatus;
  let fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  const refundStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.refundStatus;
  let token = localStorage.getItem("token");
  const [filterdUser, setFilteredUser] = useState(null);
  const [policyId, setPolicyId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [alarmevents, setAlarmEvents] = useState(null);
  const [refundBreakupList2, setRefundBreakupList2] = useState(null);
  const [generatePaymentlinks, setGeneratePaymentlinks] = useState(null);

  useEffect(() => {
    if (paymentDetailsData && bookingCancellationDetails) {
      setRefundBreakupList2([
        {
          typeText: "Base Rent",
          amount:
            paymentDetailsData?.weekdayRent + paymentDetailsData?.weekendRent,
        },
        {
          typeText: "Tax Amount",
          amount: paymentDetailsData?.taxAmount,
        },
        {
          typeText: "Delivery Charges",
          amount: paymentDetailsData?.deliveryCharges,
        },
        {
          typeText: "Pickup Charges",
          amount: paymentDetailsData?.pickupCharges,
        },
        {
          typeText: "Security Deposit",
          amount: paymentDetailsData?.securityDeposit,
        },
        {
          typeText: `Deduction ( ${policyId?.deductionPercentage} %)`,
          amount: bookingCancellationDetails[0]?.amountToBeDeducted,
        },
        {
          typeText: "Refundable Amount",
          amount: Number(
            bookingCancellationDetails[0]?.totalRefundableAmount.toFixed(2),
          ),
        },
      ]);
    }
  }, [paymentDetailsData, bookingCancellationDetails]);

  const getVehicleEventAlarms = async () => {
    let formattedDate = moment(summaryDetails?.bookFrom).format(
      "YYYY-MM-DD[T]HH:mm",
    );
    let formattedEnd = moment(summaryDetails?.bookTo).format(
      "YYYY-MM-DD[T]HH:mm",
    );
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicles/gps/event-reports?from=${formattedDate}&to=${formattedEnd}&deviceId=${vehicleDetails?.gpsDeviceId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setAlarmEvents(data?.entities);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  // useEffect(() => {
  //   if (bookingComments.length > 0) {
  //     getAISummarizedResultAPI();
  //   }
  // }, [bookingComments]);

  useEffect(() => {
    if (summaryDetails && vehicleDetails) {
      getVehicleEventAlarms();
      generatepaymentlink();
    }
  }, [summaryDetails, vehicleDetails]);

  useEffect(() => {
    if (summaryDetails) {
      getSystemUser();
    }
  }, [summaryDetails]);

  const generatepaymentlink = async (type, link) => {
    let url = `${apiUrl}/api/paymentlinks?bookingId=${summaryDetails?.id}`;
    let options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `${token}`,
      },
    };

    // If type is "actions", switch to POST
    if (type === "actions") {
      const payload = {
        paymentId: link?.paymentId,
        id: link?.id,
        bookingId: summaryDetails?.id,
        inquiryCode: summaryDetails?.inquiryCode,
      };

      url = `${apiUrl}/api/paymentlinks`; // POST usually goes to base URL
      options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      };
    }

    try {
      const response = await fetch(url, options);
      const data = await response.json();

      if (data?.statusCode === "0100") {
        if (data?.dataValues?.status === "captured") {
          toast.success("Payment Captured Successfully");
          setActiveItem("View all Bookings");
          getBookingDetail(selectedRow?.inquiryID, "inquiry");
        }
        setGeneratePaymentlinks(data?.entities?.rows);
      } else {
        toast.error(data?.message);
      }
      return data;
    } catch (error) {
      console.error("Error in paymentlinks API:", error);
    }
  };

  const getPolicyDetails = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/cancellationpolicies/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setPolicyId(data?.entityValue);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    if (bookingCancellationDetails) {
      getPolicyDetails(bookingCancellationDetails[0]?.policyId);
    }
  }, [bookingCancellationDetails]);

  const getSystemUser = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/users?limit=1000&isSystemUser=${1}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setSystemUserData(data?.entities?.rows);
        setFilteredUser(
          data?.entities?.rows.filter(
            (item) => item?.id === summaryDetails?.updatedBy,
          ),
        );
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const handleInitiateRefund = async () => {
    try {
      const refundBreakupList = [
        {
          typeText: "Base Rent",
          amount:
            paymentDetailsData?.weekdayRent + paymentDetailsData?.weekendRent,
        },
        {
          typeText: "Tax Amount",
          amount: paymentDetailsData?.taxAmount,
        },
        {
          typeText: "Delivery Charges",
          amount: paymentDetailsData?.deliveryCharges,
        },
        {
          typeText: "Pickup Charges",
          amount: paymentDetailsData?.pickupCharges,
        },
        {
          typeText: "Security Deposit",
          amount: paymentDetailsData?.securityDeposit,
        },
        {
          typeText: `Deduction ( ${policyId?.deductionPercentage} %)`,
          amount: bookingCancellationDetails[0]?.amountToBeDeducted,
        },
        {
          typeText: "Refundable Amount",
          amount: Number(
            bookingCancellationDetails[0]?.totalRefundableAmount.toFixed(2),
          ),
        },
      ];

      const response = await fetch(`${apiUrl}/api/bookingrefunds`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          bookingId: summaryDetails?.id,
          refundStatus: refundStatus?.inverted?.pending,
          bookingCode: summaryDetails?.bookingCode,
          refundableAmount: Number(
            bookingCancellationDetails[0]?.totalRefundableAmount.toFixed(2),
          ),
          customerName: summaryDetails?.customerName,
          customerMobile: summaryDetails?.customerMobile,
          customerEmail: summaryDetails?.customerEmail,
          bookingEndDate: summaryDetails?.bookTo,
          bookingObject: {
            id: summaryDetails?.id,
            // bookingStatus: fleetBookingStatus?.inverted?.refundPending,
            refundableAmount: Number(
              bookingCancellationDetails[0]?.totalRefundableAmount.toFixed(2),
            ),
          },
          cancelBookingObject: {
            id: bookingCancellationDetails[0]?.id,
            isRefundInitiated: true,
          },
          refundBreakupList,
        }),
      });

      const data = await response.json();

      if (data?.statusCode === "0100") {
        toast.success("Refund Initiated successfully");
        setTimeout(() => {
          setOpenTab(false);
        }, 300);
        getAllBookings();
      }
    } catch (error) {
      console.error("Error fetching Hub Names:", error);
      return null;
    }
  };

  // useEffect(() => {
  //   if (selectedRow?.id) {
  //     bookingExtensionDetails(selectedRow?.id);
  //     bookingRescheduleDetails(selectedRow?.id);
  //     getVehicleWappingDetails(selectedRow?.id);
  //     bookingCalleationPloicies(selectedRow?.id);
  //     getticketDetails(selectedRow?.bookingCode);
  //   }
  // }, [selectedRow]);

  function formatted(utcDate) {
    const formatted = new Date(utcDate).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

    return formatted;
  }

  return (
    <div>
      {openModal && (
        <Commonmodal
          open={openModal}
          onClose={() => setOpenModal(false)}
          url={selectedImage}
        />
      )}
      <BookingDetailsCard
        systemUserData={systemUserData}
        getAllHubsListData={getAllHubsListData}
        bookingDetailsData={paymentDetailsData}
        vehicleDetails={vehicleDetails}
      />
      {/* {from === "booking" ? ( */}
      <>
        <div className="my-4">
          <Accordion id="accordion-transactions">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              className="shadow-lg rounded-lg"
            >
              <Typography component="span">
                Booking Transaction Details
              </Typography>
            </AccordionSummary>

            <div className="p-1 h-60 overflow-auto">
              <AccordionDetails>
                <div className="">
                  <table className="mx-auto bg-white w-full text-sm text-left rounded-lg shadow-lg border border-gray-100 mt-4">
                    <thead className="">
                      <tr>
                        <th className="p-2">Payment Id</th>
                        <th className="p-2">Total Amount</th>
                        <th className="p-2">Payment Mode</th>
                        <th className="p-2">Transaction Code</th>
                        <th className="p-2">Generated At</th>
                        <th className="p-2">Attachments</th>
                        <th className="p-2">Description</th>
                        <th className="p-2">Created By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactionDetails?.length ? (
                        <>
                          {transactionDetails.map((item, index) => {
                            return (
                              <tr
                                key={item?.id}
                                className="border-b hover:bg-gray-50"
                              >
                                <td className="p-2">{item?.id || "-"}</td>
                                <td className="p-2">
                                  {"₹ " + item?.amount || "-"}
                                </td>
                                <td className="p-2">
                                  {item?.paymentMode || "-"}
                                </td>
                                <td className="p-2">
                                  {item?.transactionCode || "-"}
                                </td>
                                <td className="p-2">
                                  {formatDateAndTime(item?.createdAt)}
                                </td>
                                <td className="p-2">
                                  {item?.attachments &&
                                    (() => {
                                      try {
                                        const parsed = JSON.parse(
                                          item.attachments,
                                        );

                                        return (
                                          <div className="flex gap-2 flex-wrap">
                                            {parsed.map((file, i) => (
                                              <img
                                                key={i}
                                                src={file?.url}
                                                alt="Attachment"
                                                onClick={() => {
                                                  setOpenModal(true);
                                                  setSelectedImage(file?.url);
                                                }}
                                                className="w-12 h-12 cursor-pointer object-cover rounded"
                                              />
                                            ))}
                                          </div>
                                        );
                                      } catch {
                                        return null;
                                      }
                                    })()}
                                </td>
                                <td className="p-2">
                                  {item?.description || "-"}
                                </td>
                                <td className="p-2">
                                  {item?.createdBy
                                    ? systemUserData.find(
                                        (user) => user?.id === item?.createdBy,
                                      )?.name
                                    : "-"}
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            className="text-center p-4 text-gray-500"
                          >
                            No payments found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {generatePaymentlinks && (
                  <table className="min-w-full text-sm text-left shadow-lg border border-gray-100 mt-8">
                    <thead>
                      <tr>
                        <th className="p-4">Payment Id</th>
                        <th className="p-4">Total Amount</th>
                        <th className="p-4">Payment Url</th>
                        <th className="p-4">Status</th>
                        <th className="p-4">Generated At</th>
                        <th className="p-4 text-right">Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {generatePaymentlinks
                        // only created status rows
                        .map((link) => (
                          <tr
                            key={link.id}
                            className="border-b hover:bg-gray-50"
                          >
                            <td className="p-4">{link.paymentId}</td>
                            <td className="p-4">₹ {link.amount}</td>
                            <td className="p-4">{link.shortUrl}</td>
                            <td className="p-4">{link.status}</td>
                            <td className="p-4">
                              {formatDateAndTime(link.createdAt)}
                            </td>
                            {link.status !== "captured" && (
                              <td
                                onClick={() =>
                                  generatepaymentlink("actions", link)
                                }
                                className="p-4 text-right cursor-pointer"
                              >
                                <InfoIcon />
                              </td>
                            )}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                )}
              </AccordionDetails>
            </div>
            {/* </>
          ) : (
            <h1 className="text-center text-xl font-medium my-6">
              No Alarm Counts
            </h1>
          )} */}
          </Accordion>
        </div>

        <div className="">
          <Accordion id="accordion-alarms">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              className="shadow-lg rounded-lg"
            >
              <Typography component="span">
                Alarm Events For Device Id - {vehicleDetails?.gpsDeviceId}
              </Typography>
            </AccordionSummary>

            {/* {alarmevents ? (
            <> */}
            <div className="text-center my-4">
              {(() => {
                const events = alarmevents || [];

                // Count all alarm types dynamically
                // const counts = events?.reduce((acc, e) => {
                //   const alarmType = e?.attributes?.alarm || "";
                //   acc[alarmType] = (acc[alarmType] || 0) + 1;
                //   return acc;
                // }, {});

                // Style map for different alarm types (optional)
                const alarmColors = {
                  idle: "bg-yellow-100",
                  hardBraking: "bg-red-100",
                  accident: "bg-red-200",
                };

                return (
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 p-4">
                    {/* {Object.entries(counts).map(([type, count]) => (
                      <div
                        key={type}
                        className={`p-4 rounded-lg shadow ${
                          alarmColors[type] || "bg-gray-100"
                        }`}
                      >
                        <h1 className="text-lg font-semibold capitalize">
                          {type}{" "}
                          <span className="ml-2 text-gray-700">{count}</span>
                        </h1>
                      </div>
                    ))} */}
                  </div>
                );
              })()}
            </div>
            <div className="p-6 h-48 overflow-auto">
              {/* <AccordionDetails>
                <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
                  {(alarmevents || []).map((event) => (
                    <div
                      key={event?.id}
                      className="bg-blue-50 border-l-4 border-blue-500 rounded-lg shadow p-4 space-y-2"
                    >
                      <div className="flex justify-between items-center">
                        <span className="text-sm font-semibold text-blue-800">
                          Event ID: {event?.id || "N/A"}
                        </span>
                      </div>

                      <div className="flex items-center gap-2 text-gray-700 text-sm">
                        <span>
                          Event Time:{" "}
                          {formatDateAndTime(
                            event?.eventTime || event?.serverTime,
                          )}
                        </span>
                      </div>

                      <div className="flex items-center gap-2 text-gray-700 text-sm">
                        <span>Device ID: {event?.deviceId || "N/A"}</span>
                      </div>

                      <div className="flex items-center gap-2 text-gray-700 text-sm">
                        <span>Position ID: {event?.positionId || "N/A"}</span>
                      </div>

                      <div className="flex items-center gap-2 text-gray-700 text-sm">
                        <span>
                          Alarm Type: {event?.attributes?.alarm || "N/A"}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </AccordionDetails> */}
            </div>
            {/* </>
          ) : (
            <h1 className="text-center text-xl font-medium my-6">
              No Alarm Counts
            </h1>
          )} */}
          </Accordion>
        </div>

        {getBookingExtensionDetails?.length ? (
          <div className="my-4">
            <Accordion id="accordion-extension">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="shadow-lg rounded-lg"
              >
                <Typography component="span">Extension Details</Typography>
              </AccordionSummary>

              <div className="p-1 h-60 overflow-auto">
                <AccordionDetails>
                  <div className="">
                    <table className="mx-auto bg-white w-full text-sm text-left rounded-lg shadow-lg border border-gray-100 mt-4">
                      <thead className="">
                        <tr>
                          <th className="p-2">Weekday Rent</th>
                          <th className="p-2">Weekend Rent</th>
                          <th className="p-2">Total Free Kms</th>
                          <th className="p-2">Total Hrs</th>
                          <th className="p-2">Tax</th>
                          <th className="p-2">Total Rent</th>
                          <th className="p-2">Start Date</th>
                          <th className="p-2">End Date</th>
                          <th className="p-2">Collection Type</th>
                          <th className="p-2">Requested By</th>
                          <th className="p-2">Created Date</th>
                          <th className="p-2">Created By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {getBookingExtensionDetails.length ? (
                          <>
                            {getBookingExtensionDetails.map((item, index) => {
                              return (
                                <tr
                                  key={item?.id}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-2">
                                    {"₹ " + item?.weekdayRent}
                                  </td>
                                  <td className="p-2">
                                    {"₹ " + item?.weekendRent}
                                  </td>
                                  <td className="p-2">{item?.totalFreeKms}</td>
                                  <td className="p-2">{item?.totalHrs}</td>
                                  <td className="p-2">
                                    {"₹ " + item?.taxAmount}
                                  </td>
                                  <td className="p-2">
                                    {"₹ " + item?.totalRentWithTax}
                                  </td>
                                  <td className="p-2">
                                    {formatDateAndTime(item?.startDate)}
                                  </td>
                                  <td className="p-2">
                                    {formatDateAndTime(item?.endDate)}
                                  </td>
                                  <td className="p-2">{item?.paymentType}</td>
                                  <td className="p-2">{"-"}</td>
                                  <td className="p-2">
                                    {formatDateAndTime(item?.createdOn)}
                                  </td>
                                  <td className="p-2">
                                    {item?.modifiedBy
                                      ? systemUserData.find(
                                          (user) =>
                                            user?.id === item?.modifiedBy,
                                        )?.name
                                      : "-"}
                                  </td>
                                </tr>
                              );
                            })}
                          </>
                        ) : (
                          <tr>
                            <td
                              colSpan="6"
                              className="text-center mx-auto p-4 text-gray-500"
                            >
                              No Extesnion Details found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </AccordionDetails>
              </div>
              {/* </>
          ) : (
            <h1 className="text-center text-xl font-medium my-6">
              No Alarm Counts
            </h1>
          )} */}
            </Accordion>
          </div>
        ) : (
          <></>
        )}

        {getBookingReschduleDetails?.length ? (
          <div className="my-4">
            <Accordion id="accordion-reschedule">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="shadow-lg rounded-lg"
              >
                <Typography component="span">Reschedule Details</Typography>
              </AccordionSummary>

              <div className="p-1 h-60 overflow-auto">
                <AccordionDetails>
                  <div className="">
                    <table className="mx-auto bg-white w-full text-sm text-left rounded-lg shadow-lg border border-gray-100 mt-4">
                      <thead className="">
                        <tr>
                          <th className="p-2">Old Start Date</th>
                          <th className="p-2">Old End Date</th>
                          <th className="p-2">New Start Date</th>
                          <th className="p-2">New End Date</th>
                          <th className="p-2">Old Rent</th>
                          <th className="p-2">New Rent</th>
                          <th className="p-2">Difference Amount</th>
                          <th className="p-2">Collection Type</th>
                          <th className="p-2">Requested By</th>
                          <th className="p-2">Created Date</th>
                          <th className="p-2">Created By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {getBookingReschduleDetails.length ? (
                          <>
                            {getBookingReschduleDetails.map((item, index) => {
                              return (
                                <tr
                                  key={item?.id}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-2">
                                    {formatDateAndTime(item?.currentStartDate)}
                                  </td>
                                  <td className="p-2">
                                    {formatDateAndTime(item?.currentEndDate)}
                                  </td>
                                  <td className="p-2">
                                    {formatDateAndTime(item?.newStartDate)}
                                  </td>
                                  <td className="p-2">
                                    {formatDateAndTime(item?.newEndDate)}
                                  </td>
                                  <td className="p-2">{"₹" + item?.oldRent}</td>
                                  <td className="p-2">{"₹" + item?.newRent}</td>
                                  <td className="p-2">
                                    ₹{" "}
                                    {Number(
                                      (item?.newRent - item?.oldRent).toFixed(
                                        2,
                                      ),
                                    )}
                                  </td>
                                  <td className="p-2">{item?.paymentType}</td>
                                  <td className="p-2">{"-"}</td>
                                  <td className="p-2">
                                    {formatDateAndTime(item?.createdOn)}
                                  </td>
                                  <td className="p-2">
                                    {item?.modifiedBy
                                      ? systemUserData.find(
                                          (user) =>
                                            user?.id === item?.modifiedBy,
                                        )?.name
                                      : "-"}
                                  </td>
                                </tr>
                              );
                            })}
                          </>
                        ) : (
                          <tr>
                            <td
                              colSpan="6"
                              className="text-center mx-auto p-4 text-gray-500"
                            >
                              No Reschedule Details found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </AccordionDetails>
              </div>
              {/* </>
          ) : (
            <h1 className="text-center text-xl font-medium my-6">
              No Alarm Counts
            </h1>
          )} */}
            </Accordion>
          </div>
        ) : (
          <></>
        )}

        {vehicelSwappingDetails?.length ? (
          <div className="mt-4">
            <Accordion id="accordion-swapping">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="shadow-lg rounded-lg"
              >
                <Typography component="span">Swapping Details</Typography>
              </AccordionSummary>

              <div className="p-1 h-60 overflow-auto">
                <AccordionDetails>
                  <div className="">
                    <table className="mx-auto bg-white w-full text-sm text-left rounded-lg shadow-lg border border-gray-100 mt-4">
                      <thead className="">
                        <tr>
                          <th className="p-2">Previous Vehicle No</th>
                          <th className="p-2">Previous Vehicle Name</th>
                          <th className="p-2">Vehicle No</th>
                          <th className="p-2">Vehicle Name</th>
                          {/* <th className="p-2">Reason</th> */}
                          <th className="p-2">Previous Rent</th>
                          <th className="p-2">New Rent</th>
                          <th className="p-2">Difference Amount</th>
                          <th className="p-2">Collection Type</th>
                          <th className="p-2">Requested By</th>
                          <th className="p-2">Created Date</th>
                          <th className="p-2">Created By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {vehicelSwappingDetails.length ? (
                          <>
                            {vehicelSwappingDetails.map((item, index) => {
                              return (
                                <tr
                                  key={item?.id}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-2">
                                    {item?.previousVehicleRegistrationNo}
                                  </td>
                                  <td className="p-2">
                                    {item?.previousVehicleName}
                                  </td>
                                  <td className="p-2">
                                    {item?.vehicleRegistrationNo}
                                  </td>
                                  <td className="p-2">{item?.vehicleName}</td>
                                  <td className="p-2">
                                    {"₹" + item?.previousRent}
                                  </td>
                                  <td className="p-2">{"₹" + item?.newRent}</td>
                                  <td className="p-2">
                                    ₹{" "}
                                    {Number(
                                      (
                                        item?.newRent - item?.previousRent
                                      ).toFixed(2),
                                    )}
                                  </td>
                                  <td className="p-2">{item?.paymentType}</td>
                                  <td className="p-2">{item?.requestedBy}</td>
                                  <td className="p-2">
                                    {formatDateAndTime(item?.createdOn)}
                                  </td>
                                  <td className="p-2">
                                    {item?.modifiedBy
                                      ? systemUserData.find(
                                          (user) =>
                                            user?.id === item?.modifiedBy,
                                        )?.name
                                      : "-"}
                                  </td>
                                </tr>
                              );
                            })}
                          </>
                        ) : (
                          <tr>
                            <td
                              colSpan="6"
                              className="text-center mx-auto p-4 text-gray-500"
                            >
                              No Extesnion Details found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </AccordionDetails>
              </div>
              {/* </>
          ) : (
            <h1 className="text-center text-xl font-medium my-6">
              No Alarm Counts
            </h1>
          )} */}
            </Accordion>
          </div>
        ) : (
          <></>
        )}

        {bookingCancellationDetails?.length ? (
          <div className="mt-4">
            <Accordion id="accordion-cancellation">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="shadow-lg rounded-lg"
              >
                <Typography component="span">Cancellation Details</Typography>
              </AccordionSummary>

              <div className="p-1 h-60 overflow-auto">
                <AccordionDetails>
                  <div className="">
                    <table className="mx-auto bg-white w-full text-sm text-left rounded-lg shadow-lg border border-gray-100 mt-4">
                      <thead className="">
                        <tr>
                          <th className="p-1.5">
                            Policy {policyId?.deductionPercentage + "%"}
                          </th>
                          <th className="p-1.5">Amount To Be Deducted</th>
                          <th className="p-1.5">Amount to be Refunded</th>
                          <th className="p-1.5">
                            Refundable Amount (With Security Deposit)
                          </th>
                          <th className="p-1.5">Reason</th>
                          <th className="p-1.5">Requested By</th>
                          <th className="p-2">Created Date</th>
                          <th className="p-1.5">Created By</th>
                          {Number(
                            fleetBookingStatus?.inverted?.refundPending,
                          ) === summaryDetails?.bookingStatus ||
                          Number(
                            fleetBookingStatus?.inverted?.bookingClosed,
                          ) === summaryDetails?.bookingStatus ? (
                            <></>
                          ) : (
                            <th className="p-1.5">Action</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {bookingCancellationDetails.length ? (
                          <>
                            {bookingCancellationDetails.map((item, index) => {
                              return (
                                <tr
                                  key={item?.id}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-1.5">
                                    {item?.policyId === policyId?.id &&
                                      policyId?.name}
                                  </td>
                                  <td className="p-1.5">
                                    {"₹" + item?.amountToBeDeducted}
                                  </td>
                                  <td className="p-1.5">
                                    {"₹" +
                                      Number(item?.amountRefunded?.toFixed(2))}
                                  </td>
                                  <td className="p-1.5">
                                    {"₹" +
                                      Number(
                                        (item?.totalRefundableAmount).toFixed(
                                          2,
                                        ),
                                      )}
                                  </td>
                                  <td className="p-1.5">{item?.reason}</td>
                                  <td className="p-1.5">{item?.requestedBy}</td>
                                  <td className="p-2">
                                    {formatDateAndTime(item?.createdAt)}
                                  </td>
                                  <td className="p-2">
                                    {(item?.createdBy &&
                                      systemUserData.find(
                                        (user) => user?.id === item?.createdBy,
                                      )?.name) ||
                                      "-"}
                                  </td>
                                  {summaryDetails?.bookingStatus ===
                                    Number(
                                      fleetBookingStatus?.inverted?.cancelled,
                                    ) &&
                                    !paymentDetailsData?.refundDetails
                                      ?.refundStatus &&
                                    summaryDetails?.bookingStatus !==
                                      Number(
                                        fleetBookingStatus?.inverted
                                          ?.bookingClosed,
                                      ) && (
                                      <td>
                                        <button
                                          onClick={handleInitiateRefund}
                                          className="w-28 h-10 bg-blue-400 rounded-full"
                                        >
                                          Initiate Refund
                                        </button>
                                      </td>
                                    )}
                                </tr>
                              );
                            })}
                          </>
                        ) : (
                          <tr>
                            <td
                              colSpan="6"
                              className="text-center mx-auto p-4 text-gray-500"
                            >
                              No Extesnion Details found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <table className="min-w-full text-sm text-center shadow-lg border border-gray-100 mt-8">
                      <thead className="">
                        <tr>
                          <th className="p-4">Line Items</th>
                          <th className="p-4">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {refundBreakupList2?.length > 0 ? (
                          refundBreakupList2.map((txn, index) => (
                            <tr
                              key={index}
                              className="border-b hover:bg-gray-50"
                            >
                              <td className="p-4">{txn?.typeText}</td>
                              <td className="p-4">
                                {"₹ " +
                                  (txn?.amount > 0
                                    ? Math.round(txn?.amount)
                                    : txn?.amount)}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="text-center p-4 text-gray-500">
                              N/A
                            </td>
                            <td className="text-center p-4 text-gray-500">
                              N/A
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </AccordionDetails>
              </div>
            </Accordion>
          </div>
        ) : (
          <></>
        )}

        <div className="mt-4">
          <Aisummarizecomment
            getAISummarizedResultAPI={getAISummarizedResultAPI}
            aiSummarizedResult={aiSummarizedResult}
            aiSummarizeLoading={aiSummarizeLoading}
          />
        </div>

        {/* {ticketDetails?.length ? (
          <div className="">
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="shadow-lg rounded-lg"
              >
                <Typography component="span">Swapping Details</Typography>
              </AccordionSummary>

              <div className="p-1 h-60 overflow-auto">
                <AccordionDetails>
                  <div className="">
                    <table className="mx-auto bg-white w-full text-sm text-left rounded-lg shadow-lg border border-gray-100 mt-4">
                      <thead className="">
                        <tr>
                          <th className="p-4">Ticket Id</th>
                          <th className="p-4">Topic</th>
                          <th className="p-4">Status</th>
                          <th className="p-4">Priority</th>
                          <th className="p-4">Assigned To</th>
                          <th className="p-4">Created By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ticketDetails.length ? (
                          <>
                            {ticketDetails.map((item, index) => {
                              return (
                                <tr
                                  key={item?.id}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-4">
                                    {item?.previousVehicleRegistrationNo}
                                  </td>
                                  <td className="p-4">
                                    {item?.previousVehicleName}
                                  </td>
                                  <td className="p-4">
                                    {item?.vehicleRegistrationNo}
                                  </td>
                                  <td className="p-4">{item?.vehicleName}</td>
                                  <td className="p-4">{item?.requestedBy}</td>
                                  <td className="p-2">
                                    {item?.modifiedBy
                                      ? systemUserData.find(
                                          (user) =>
                                            user?.id === item?.modifiedBy
                                        )?.name
                                      : "-"}
                                  </td>
                                </tr>
                              );
                            })}
                          </>
                        ) : (
                          <tr>
                            <td
                              colSpan="6"
                              className="text-center mx-auto p-4 text-gray-500"
                            >
                              No Extesnion Details found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </AccordionDetails>
              </div>
             
          
            </Accordion>
          </div>
        ) : (
          <></>
        )} */}
      </>
      {/* ) : (
        <></>
      )} */}
    </div>
  );
};

export default Summary;
